import { useEffect, useRef, useState } from "react";
import { Button, Dialog } from "@mui/material";
import axios from "axios";
import React from "react";
import axois from "../../configs/axois";
import baseURL from "../../configs/api";
import UsernameValidatedComponent from "../../components/UsernameValidatedComponent";
import PasswordValidation from "../../components/PasswordValidation";
import { getEmailCheckingFromJVCRM } from "../../services/EmailChecking";
import useAuth from "../../components/hooks/useAuth";
import PleaseWaitPopup from "../PleaseWaitPopup";
import useProfile from "../../components/hooks/useProfile";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import PhoneNumberInput from "../../components/common/PhoneNumberInput";
import { useTheme } from "../../components/hooks/useTheme";
import colorConfigs from "../../configs/colorConfigs";
import useGeneral from "../../components/hooks/useGeneral";
import EmailAlreadyExistCheckingWithoutTenant from "../../components/EmailAlreadyExistCheckingWithoutTenant";
import useTenant from "../../components/hooks/useTenant";
import useConfirm from "../../components/hooks/useConfirm";

export const Profile = () => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { themeStyles } = useTheme();
    const { auth, setAuth }: any = useAuth();
    const { handleTenantError }: any = useTenant();
    const { generalSetting }: any = useGeneral();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const { profileOpen, setProfileOpen }: any = useProfile();
    const [currUserName, setCurrUserName] = useState<string>("");
    const [firstName, setFirstName] = useState<string>("");
    const [userData, setUserData] = useState<any>({});
    const [lastName, setLastName] = useState<string>("");
    const [userName, setUserName] = useState<string>("");
    const [emailAddress, setEmailAddress] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [mobilPhoneNumber, setMobilePhoneNumber] = useState<string>("");
    const [language, setLanguage] = useState<string>("English");
    const [agentCompany, setAgentCategory] = useState<string>("0");
    const [dateFormat, setDateFormat] = useState<string>("");
    const [usernameTouched, setUsernameTouched] = useState<boolean>(false);
    const [emailTouched, setEmailTouched] = useState<boolean>(false);
    const [isValidPassword, setIsValidPassword] = useState<boolean>(false);
    const [passwordTouched, setPasswordTouched] = useState<boolean>(false);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
    const [disabeld, setDisabled] = useState<boolean>(true);
    const [imagePath, setImagePath] = useState<string>("");
    const inputFileRef = useRef<HTMLInputElement>(null);
    const [uploadFileImg, setUploadFileImg] = useState<FileList | null>(null);
    const [isUsernameChecking, setIsUsernameChecking] = useState<boolean>(false);
    const [isEmailChecking, setIsEmailChecking] = useState<boolean>(false);

    useEffect(() => {
        if (profileOpen) {
            setUploadFileImg(null);
            setPleaseWaitPopup(true)
            axois
                .get(`${baseURL}users/${auth?.id}`, {
                    headers: {
                        'X-Tenant-ID': tenantId
                    },
                })
                .then((response) => {
                    setCurrUserName(response?.data?.firstName + " " + response?.data?.lastName);
                    setUserData(response.data);
                    setFirstName(response.data.firstName);
                    setLastName(response.data.lastName);
                    setUserName(response.data.userName);
                    setEmailAddress(response.data.emailAddress);
                    setDateFormat(response.data.dateFormat);
                    setMobilePhoneNumber(response.data.mobilPhoneNumber);
                    setLanguage(response.data.language);
                    setAgentCategory(response.data.agentCompany);
                    setImagePath(response.data.imagePath)
                    setPleaseWaitPopup(false);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                    handleTenantError(error);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profileOpen]);

    const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFiles = e.target.files as FileList;
        if (selectedFiles.length !== 0) {
            setUploadFileImg(selectedFiles);
        }
    };

    const getData = (accessToken: string, uploadedImagePath: string) => {
        const jsonData: any = jwtDecode(accessToken);
        const id = jsonData["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"];
        const roles = jsonData["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
        const givenname = jsonData["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname"];
        const emailAddress = jsonData["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];

        Cookies.set("tenantId-jj-rental-ui", tenantId, {
            expires: jsonData.exp,
        });
        Cookies.set("token-jj-rental-ui", accessToken, {
            expires: jsonData.exp
        });
        Cookies.set("role-jj-rental-ui", roles, {
            expires: jsonData.exp,
        });
        Cookies.set("roleId-jj-rental-ui", Cookies.get("roleId-jj-rental-ui") || '0', {
            expires: jsonData.exp,
        });
        Cookies.set("userId-jj-rental-ui", id, {
            expires: jsonData.exp,
        });
        Cookies.set("isAdmin-jj-rental-ui", auth?.IsAdmin ? "1" : "0", {
            expires: jsonData.exp,
        });

        Cookies.set("profileImg-jj-rental-ui", uploadedImagePath, {
            expires: jsonData.exp,
        });

        Cookies.set("companyName-jj-rental-ui", auth?.companyName, {
            expires: jsonData.exp,
        });

        setAuth({ id, userName: auth?.userName, givenname, emailAddress, roles, accessToken, companyName: auth?.companyName, IsAdmin: auth?.IsAdmin ? "1" : "0" });
        setPleaseWaitPopup(false);
        setProfileOpen(false);
    }

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (isUsernameChecking || isEmailChecking) return;

        setPleaseWaitPopup(true);

        let uploadedImagePath = imagePath;

        if (uploadFileImg && uploadFileImg?.length > 0) {
            const formData = new FormData();
            formData.append("ImageFile", uploadFileImg[0]);

            try {
                const uploadRes = await axios.post(`${baseURL}commonFile/Upload`, formData, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "multipart/form-data"
                    },
                    withCredentials: true,
                });

                uploadedImagePath = uploadRes?.data;
                setImagePath(uploadedImagePath);
                handleTenantError(null);
            } catch (err) {
                handleTenantError(err);
            }
        }

        await axios
            .put(
                `${baseURL}Auth/UpdateUserProfile?userId=${auth?.id}`,
                JSON.stringify({
                    ...userData,
                    id: parseInt(auth?.id),
                    firstName,
                    lastName,
                    password,
                    mobilPhoneNumber,
                    dateFormat,
                    language,
                    agentCompany,
                    emailAddress,
                    imagePath: uploadedImagePath,
                }),
                {
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "application/json"
                    },
                    withCredentials: true,
                }
            )
            .then((response) => {
                getData(response.data, uploadedImagePath);
                handleTenantError(null);
            })
            .catch((error) => {
                const errorMessage = error?.response?.data || error?.message || "File upload failed.";
                setConfirmData({
                    title: 'Warning',
                    summary: errorMessage,
                    confirmBtn: 'Ok',
                    isConfirm: (callback: any) => {
                        callback();
                    }
                });
                setConfirmPopup(true);
                setPleaseWaitPopup(false);
                handleTenantError(error);
            });
    };

    return (
        <>
            <Dialog
                open={profileOpen}
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '800px',
                        width: '100%',
                        borderRadius: '16px',
                    },
                }}
            >
                <div className={`px-[24px] py-[10px] h-full ${themeStyles.main.tailwindSectionBg}`}>
                    <div className={`w-full bg-transparent rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
                        <div className="w-full mt-2">
                            <div className={`w-full pb-4`}>
                                <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                    <div className="flex items-center gap-1.5">
                                        <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Profile - {currUserName}</h2>
                                    </div>

                                    {
                                        disabeld && (
                                            <button className={`px-[8px] py-[6px] bg-transparent shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                                                onClick={() => setDisabled(false)}
                                            >
                                                <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textSubHeadingColor}`}>
                                                    edit
                                                </span>
                                                <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>Edit</span>
                                            </button>
                                        )
                                    }
                                </div>

                                <div className="mt-2 p-2">
                                    <form onSubmit={(e) => handleSubmit(e)}>
                                        <div className="w-full">
                                            <div>
                                                {
                                                    uploadFileImg && uploadFileImg?.length > 0 && uploadFileImg?.item(0)
                                                        ? (
                                                            <img
                                                                className="w-[100px] h-[100px] rounded-sm"
                                                                alt="uploaded preview"
                                                                src={URL.createObjectURL(uploadFileImg?.item(0)!)}
                                                                onError={({ currentTarget }) => {
                                                                    currentTarget.onerror = null;
                                                                    currentTarget.src = "./images/profile-placeholder.png";
                                                                }}
                                                            />
                                                        ) : (
                                                            imagePath && (
                                                                <img
                                                                    className="w-[100px] h-[100px] rounded-sm"
                                                                    alt="profileImg"
                                                                    src={`${baseURL}commonFile/Get?name=${imagePath}`}
                                                                    onError={({ currentTarget }) => {
                                                                        currentTarget.onerror = null;
                                                                        currentTarget.src = "./images/profile-placeholder.png";
                                                                    }}
                                                                />
                                                            )
                                                        )
                                                }

                                                <div className="grid grid-cols-3 gap-6">
                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Upload Profile Picture</label>
                                                        <input
                                                            name="profilepic"
                                                            type="file"
                                                            accept="image/*"
                                                            className={`block w-full rounded border ${themeStyles.form.tailwindBorderColor} px-3 py-2 shadow-sm outline-none text-sm ${themeStyles.form.tailwindLabelTextColor} placeholder:text-gray-400 focus:border-[#167AC3] ${themeStyles.form.tailwindInputTextColor} focus:ring-[#167AC3] focus:ring-offset-1 mt-1 bg-transparent`}
                                                            onChangeCapture={onFileChangeCapture}
                                                            ref={inputFileRef}
                                                            disabled={disabeld}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-3 gap-6 mt-6">
                                                {/* First Column */}
                                                <div className="space-y-4">
                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>First Name</label>
                                                        <input
                                                            type="text"
                                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                            value={firstName}
                                                            disabled={disabeld}
                                                            onChange={(e) => setFirstName(e.target.value)}
                                                            required
                                                        />
                                                    </div>

                                                    <div>
                                                        <UsernameValidatedComponent
                                                            userName={userName}
                                                            setUserName={setUserName}
                                                            touched={usernameTouched}
                                                            setTouched={setUsernameTouched}
                                                            setIsChecking={setIsUsernameChecking}
                                                            disabeld={disabeld}
                                                            className={{
                                                                label: {
                                                                    fontSize: "12px",
                                                                    fontWeight: 500,
                                                                    color: themeStyles.form.labelTextColor
                                                                },
                                                                input: {
                                                                    width: "100%",
                                                                    fontSize: "14px",
                                                                    borderRadius: "6px",
                                                                    outline: "none",
                                                                    color: themeStyles.form.inputTextColor
                                                                },
                                                                successMessage: {
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    marginTop: '0.25rem',
                                                                    fontSize: '0.75rem',
                                                                    color: '#00b300',
                                                                },
                                                                errorMessage: {
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    marginTop: '0.25rem',
                                                                    fontSize: '0.75rem',
                                                                    color: '#ff3333',
                                                                },

                                                            }}
                                                        />
                                                    </div>
                                                    {
                                                        !disabeld && (
                                                            <div>
                                                                <PasswordValidation
                                                                    password={password}
                                                                    setPassword={setPassword}
                                                                    isValid={isValidPassword}
                                                                    setIsValid={setIsValidPassword}
                                                                    touched={passwordTouched}
                                                                    setTouched={setPasswordTouched}

                                                                    className={{
                                                                        label: {
                                                                            fontSize: "12px",
                                                                            fontWeight: 500,
                                                                            color: themeStyles.form.labelTextColor
                                                                        },
                                                                        input: {
                                                                            width: "100%",
                                                                            fontSize: "14px",
                                                                            borderRadius: "6px",
                                                                            outline: "none",
                                                                            color: themeStyles.form.inputTextColor
                                                                        },
                                                                        successMessage: {
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            marginTop: '0.25rem',
                                                                            fontSize: '0.75rem',
                                                                            color: '#00b300',
                                                                        },
                                                                        errorMessage: {
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            marginTop: '0.25rem',
                                                                            fontSize: '0.75rem',
                                                                            color: '#ff3333',
                                                                        },
                                                                    }}
                                                                    required={false}
                                                                />
                                                            </div>
                                                        )
                                                    }

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Mobile Number</label>

                                                        <PhoneNumberInput
                                                            name={"phoneNumber"}
                                                            value={mobilPhoneNumber}
                                                            setValue={setMobilePhoneNumber}
                                                            disabeld={disabeld}
                                                            fontSize={"14px"}
                                                            required={true}
                                                        />
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Date Format</label>
                                                        <select
                                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                            value={dateFormat}
                                                            disabled={disabeld}
                                                            onChange={(e) => setDateFormat(e.target.value)}
                                                        >
                                                            <option value="MM/dd/yyyy KK:mm a">Use System Default</option>
                                                            <option value="yyyy-MM-dd kk:mm">2023-06-16 7:37 ()</option>
                                                            <option value="yyyy-MM-dd kk:mm iso">2023-06-16 7:37 (iso)</option>
                                                            <option value="dd-MM-yyyy kk:mm">16-06-2023 7:37 (eu)</option>
                                                            <option value="MM/dd/yyyy KK:mm a us">06/16/2023 7:37 AM (us)</option>
                                                            <option value="dd/MM/yyyy KK:mm a">16/06/2023 7:37 AM (ve)</option>
                                                            <option value="dd.MM.yyyy KK:mm a">16.06.2023 7:37 AM (int)</option>
                                                            <option value="dd-MMMM-yyyy KK:mm a">16-Jun-2023 7:37 AM (id)</option>
                                                            <option value="dd.MM.yyyy kk:mm">16.06.2023 7:37 (ch)</option>
                                                        </select>
                                                    </div>

                                                </div>

                                                {/* Second Column */}
                                                <div className="space-y-4">
                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Last Name</label>
                                                        <input
                                                            type="text"
                                                            disabled={disabeld}
                                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                            value={lastName}
                                                            onChange={(e) => setLastName(e.target.value)}
                                                            required
                                                        />
                                                    </div>

                                                    <div>
                                                        <EmailAlreadyExistCheckingWithoutTenant
                                                            emailAddress={emailAddress}
                                                            setEmailAddress={setEmailAddress}
                                                            getEmailChecking={getEmailCheckingFromJVCRM}
                                                            disabeld={disabeld}
                                                            touched={emailTouched}
                                                            setTouched={setEmailTouched}
                                                            setIsChecking={setIsEmailChecking}
                                                            className={{
                                                                label: {
                                                                    fontSize: "12px",
                                                                    fontWeight: 500,
                                                                    color: themeStyles.form.labelTextColor
                                                                },
                                                                input: {
                                                                    width: "100%",
                                                                    fontSize: "14px",
                                                                    borderRadius: "6px",
                                                                    outline: "none",
                                                                    color: themeStyles.form.inputTextColor
                                                                },
                                                                successMessage: {
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    marginTop: '0.25rem',
                                                                    fontSize: '0.75rem',
                                                                    color: '#00b300',
                                                                },
                                                                errorMessage: {
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    marginTop: '0.25rem',
                                                                    fontSize: '0.75rem',
                                                                    color: '#ff3333',
                                                                },

                                                            }}
                                                        />
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Language</label>
                                                        <select
                                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                            value={language}
                                                            disabled={disabeld}
                                                            onChange={(e) => setLanguage(e.target.value)}
                                                        >
                                                            <option value="English">English</option>
                                                        </select>
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>RA Agent Category</label>
                                                        <select
                                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                            value={agentCompany}
                                                            disabled={disabeld}
                                                            onChange={(e) => setAgentCategory(e.target.value)}
                                                        >
                                                            <option className={`${themeStyles.main.tailwindSectionBg}`} value="0">{generalSetting?.companyName || "None"}</option>
                                                            <option className={`${themeStyles.main.tailwindSectionBg}`} value="1">Rd Rental</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Buttons */}
                                            <div className="flex gap-4 mt-6">
                                                {
                                                    !disabeld && (
                                                        <Button variant="contained"
                                                            sx={{
                                                                backgroundColor: colorConfigs.btn.main.bg
                                                            }}
                                                            type="submit"
                                                            disabled={isUsernameChecking || isEmailChecking}
                                                        >
                                                            {isUsernameChecking || isEmailChecking ? "Processing..." : "Save"}
                                                        </Button>
                                                    )
                                                }

                                                <Button variant="contained"
                                                    sx={{
                                                        backgroundColor: colorConfigs.btn.cancel.bg,
                                                        border: colorConfigs.btn.cancel.border,
                                                        color: colorConfigs.btn.cancel.color
                                                    }}
                                                    onClick={() => {
                                                        setDisabled(true);
                                                        setProfileOpen(false);
                                                    }}
                                                >
                                                    Cancel
                                                </Button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>

            <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
        </>
    )
}